import React, { ReactNode } from "react";
import { Modal } from "antd";
import Title from "antd/es/typography/Title";

interface Props {
  children: React.ReactNode;
  open?: boolean;
  onClose: Function;
  title?: string | ReactNode;
  titleComponent?: React.ReactNode;
  className?: string;
  size?: "xl" | "l" | "md" | "sm";
  closeIcon?: boolean;
}

const CustomModal = (props: Props) => {
  const { onClose, children, open, title, size, titleComponent, closeIcon } =
    props;
  let widthClass = "!w-2/5 !max-w-3xl";
  const handleOk = () => {
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const modalStyles = {
    mask: {
      backgroundColor: "rgba(0, 0, 0, 0.77)",
    },
  };
  if (size === "xl") {
    widthClass = "!w-4/5 !max-w-screen-2xl";
  } else if (size === "l") {
    widthClass = "!w-3/5 !max-w-6xl";
  } else if (size === "sm") {
    widthClass = "!w-1/5 !max-w-sm";
  }
  return (
    <>
      <Modal
        className={`${widthClass} max-sm:!w-full sm:!w-full`}
        title={
          titleComponent ? titleComponent : <Title level={1}>{title}</Title>
        }
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        maskClosable={false}
        styles={modalStyles}
        closeIcon={closeIcon ?? true}
      >
        {children}
      </Modal>
    </>
  );
};

export default CustomModal;
